type SvgIconProps = {
  className?: string
}

const iconProps = {
  width: 18,
  height: 18,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true as const,
}

export const IconCheck = ({ className }: SvgIconProps) => (
  <svg className={className} {...iconProps}>
    <path d="M20 6 9 17l-5-5" />
  </svg>
)

export const IconPencil = ({ className }: SvgIconProps) => (
  <svg className={className} {...iconProps}>
    <path d="M12 20h9" />
    <path d="M16.5 3.5a2.121 2.121 0 1 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
  </svg>
)

export const IconTrash = ({ className }: SvgIconProps) => (
  <svg className={className} {...iconProps}>
    <path d="M3 6h18" />
    <path d="M8 6V4h8v2" />
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />
    <path d="M10 11v6" />
    <path d="M14 11v6" />
  </svg>
)

/** Undo / restore excluded import row. */
export const IconUndo = ({ className }: SvgIconProps) => (
  <svg className={className} {...iconProps}>
    <path d="M3 7v6h6" />
    <path d="M21 17a9 9 0 0 0-9-9 9 9 0 0 0-6.7 2.9L3 13" />
  </svg>
)

export const IconLogout = ({ className }: SvgIconProps) => (
  <svg className={className} {...iconProps}>
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <path d="m16 17 5-5-5-5" />
    <path d="M21 12H9" />
  </svg>
)
